import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../../../../global/global.service';
import { Observable } from 'rxjs';
import { IProducts } from '../../../service/interface';
import { BackEndApiService } from '../../../service/back-end-api.service';
import { FormControl, FormGroup, NgForm } from '@angular/forms';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import {UrlService} from '../../../../global/url.service';

@Component({
  selector: 'app-edit-products',
  templateUrl: './edit-products.component.html',
  styleUrls: ['./edit-products.component.css']
})
export class EditProductsComponent implements OnInit {
  itemDetails: Observable<Array<IProducts>>;
  media = this.url.Media;
  optionValueCategories;

  /** upload file */
  /** add module ReactiveFormsModule */
  /** add in constructor private httpUploadFile: HttpClient */
  imageSrc: any;
  myForm: any;

  constructor(
    private global: GlobalService,
    private api: BackEndApiService,
    private route: ActivatedRoute,
    private httpUploadFile: HttpClient,
    private url: UrlService
  ) { }

  ngOnInit(): void {
    this.global.dialogPreloader();
    this.itemDetails = this.route.paramMap.pipe(
      switchMap((params: ParamMap) => this.api.getProduct(params.get('id')))
    );
    this.itemDetails.subscribe(props => {
      if (props) {
        const stringifyItemDetails = JSON.stringify(props);
        const parseItemDetails = JSON.parse(stringifyItemDetails);

        this.global.hideDialog();

        /** upload file */
        this.myForm = new FormGroup({
          currentID: new FormControl(parseItemDetails.id),
          file: new FormControl(''),
          fileSource: new FormControl('')
        });

      }
    });
    this.api.getCategories().subscribe(props => {
      this.optionValueCategories = props;
    });
  }

  onSaveChanges(update: NgForm): void {
    const product: IProducts = {
      id: update.form.value.id,
      indexProduct: update.form.value.indexProduct,
      modelProduct: update.form.value.modelProduct,
      videoYoutube: update.form.value.videoYoutube,
      priceProduct: update.form.value.priceProduct,
      timeVideoAll: update.form.value.timeVideoAll,
      timeVideoStart: update.form.value.timeVideoStart,
      timeVideoEnd: update.form.value.timeVideoEnd,
      shootsProduct: update.form.value.shootsProduct,
      caliberProduct: update.form.value.caliberProduct,
      dimensionsProduct: update.form.value.dimensionsProduct,
      categoryProduct: update.form.value.categoryProduct,
      descriptionProduct: update.form.value.descriptionProduct,
      statusPublicationProduct: update.form.value.statusPublicationProduct
    };

    this.api.updateProduct(product).subscribe(props => {
      console.log(props);
      this.global.dialogSuccessSaveEdit();
    });

  }

  /** upload file start */
  get f(): void {
    return this.myForm.controls;
  }
  onFileChange(event: any): void {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.imageSrc = reader.result as string;
        this.myForm.patchValue({
          fileSource: reader.result
        });
      };
    }
  }
  onSendFile(): void {
    /** upload file start */
    // tslint:disable-next-line:max-line-length
    this.httpUploadFile.post(this.url.Upload + 'product', this.myForm.value).subscribe(props => {
      console.log(props);
      this.global.dialogSuccessUploadFile();
    });
  }
}
